import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import FanchaLogo from "./FanchaLogo";

const NAV_LINKS = [
  { label: "首页", to: "/" },
  { label: "反转档案", to: "/#cases" },
  { label: "吃瓜方法论", to: "/#method" },
  { label: "关于我们", to: "/about" },
];

export default function FanchaHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/?q=${encodeURIComponent(q)}` : "/#cases");
    setSearchOpen(false);
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/85 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <FanchaLogo />

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-1.5">
          {/* 搜索 */}
          <div
            className={`flex items-center overflow-hidden rounded-full border bg-background-50 transition-all ${
              searchOpen ? "w-44 border-background-300 px-1 py-0.5" : "w-9 border-transparent"
            }`}
          >
            {searchOpen && (
              <form onSubmit={submitSearch} className="flex w-full items-center">
                <input
                  autoFocus
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜当事人 / 事件"
                  className="w-full bg-transparent px-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                  aria-label="搜索反差事件"
                />
                <button
                  type="submit"
                  className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-full text-foreground-700 hover:bg-background-100"
                  aria-label="搜索"
                >
                  <i className="ri-search-line text-sm" />
                </button>
              </form>
            )}
            {!searchOpen && (
              <button
                type="button"
                onClick={() => setSearchOpen(true)}
                className="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full text-foreground-700 hover:bg-background-100"
                aria-label="展开搜索"
              >
                <i className="ri-search-line" />
              </button>
            )}
          </div>

          {/* 投稿CTA */}
          <Link
            to="/#contribute"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            提供线索
          </Link>

          {/* 移动端菜单按钮 */}
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 lg:hidden"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {/* 移动端菜单面板 */}
      {menuOpen && (
        <nav
          className="border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden"
          aria-label="移动端导航"
        >
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/#contribute"
              onClick={() => setMenuOpen(false)}
              className="mt-1 rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              提供线索
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}